import { gql, useQuery } from "@apollo/client";
import { ReadMeOSSContent } from "./schema/ReadMeOSSContent";

export const readMeOSSContent = gql`
  query ReadMeOSSContent {
    configuration {
      getReadmeOss {
        fileContent
      }
    }
  }
`;

export default function useQueryReadMeOSSContent() {
  return useQuery<ReadMeOSSContent>(readMeOSSContent);
}
